import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reset posisi scroll ke paling atas setiap kali pindah halaman (route
 * berubah). React Router tidak melakukan ini secara otomatis seperti
 * navigasi browser biasa — tanpa ini, pindah menu dari tengah/bawah
 * halaman sebelumnya bakal mempertahankan posisi scroll yang sama di
 * halaman baru.
 *
 * Sengaja tidak reset saat cuma query string yang berubah pada path yang
 * sama (mis. filter/search di halaman yang sama) — hanya saat `pathname`
 * berbeda, supaya interaksi semacam itu tidak ikut lompat ke atas.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}